<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题文本">
        <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="图例显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="图例位置(X)">
        <e-chart-position v-model="attribute.legend.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="图例位置(Y)">
        <e-chart-position v-model="attribute.legend.top" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="图例布局方式">
        <t-radio-group v-model="attribute.legend.orient" size="small">
          <t-radio-button value="vertical">纵向</t-radio-button>
          <t-radio-button value="horizontal">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="图例字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图例文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="内边距" :expand="false">
      <t-form-item label="内边距(左)">
        <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(上)">
        <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(右)">
        <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(下)">
        <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="x轴">
        <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="指示文字">
        <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40"/>
      </t-form-item>
      <t-form-item label="轴线显示">
        <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="刻度线">
        <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color" size="small"/>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="字体倾斜">
        <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴(左)" :expand="false">
      <t-form-item label="y轴">
        <t-switch v-model="attribute.yAxis[0].show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis[0].axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.yAxis[0].axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="文本格式">
        <t-input v-model="attribute.yAxis[0].axisLabel.formatter" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.yAxis[0].splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴(右)" :expand="false">
      <t-form-item label="y轴">
        <t-switch v-model="attribute.yAxis[1].show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis[1].axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="字号">
        <t-input-number v-model="attribute.yAxis[1].axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="文本格式">
        <t-input v-model="attribute.yAxis[1].axisLabel.formatter" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.yAxis[1].splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="true">
      <t-form-item label="数值显示">
        <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="数值字体">
        <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="数值颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small"/>
      </t-form-item>
      <t-form-item label="数值位置">
        <t-select v-model="attribute.series.label.position" size="small">
          <t-option label="顶部" value="top"/>
          <t-option label="左" value="left"/>
          <t-option label="右" value="right"/>
          <t-option label="底部" value="bottom"/>
          <t-option label="中心" value="inside"/>
        </t-select>
      </t-form-item>
      <t-form-item>
        <template slot="label">
          数值单位
          <t-tooltip content="双Y轴/多Y轴折线柱状图的数值单位需要在数据中包含unit字段" :overlay-style="{ width: '200px' }" placement="top-right" show-arrow>
            <t-icon name="info-circle"/>
          </t-tooltip>
        </template>
        <t-switch v-model="attribute.series.label.unit" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="柱体" :expand="true">
      <t-form-item label="柱体背景">
        <t-switch v-model="attribute.series.showBackground" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="柱体宽度">
        <t-input-number v-model="attribute.series.barWidth" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="平滑曲线">
        <t-switch v-model="attribute.series.smooth" :label="['开', '关']" size="small" />
      </t-form-item>
    </e-collapse>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
    </t-form-item>
    <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
        <t-switch v-model="attribute.dataZoom.show"/> 
    </t-form-item>
    <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
      <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
    </t-form-item> 
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data';
export default {
  name: "cpt-chart-line-dual-option",
  components: {EColorGroup, EChartPosition,CptData},
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>
</style>
